import { render, staticRenderFns } from "./advancedLaws.vue?vue&type=template&id=2fe117ba&scoped=true"
import script from "./advancedLaws.vue?vue&type=script&lang=js"
export * from "./advancedLaws.vue?vue&type=script&lang=js"
import style0 from "./advancedLaws.vue?vue&type=style&index=0&id=2fe117ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe117ba",
  null
  
)

export default component.exports